import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=56699aea&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=56699aea&prod&scoped=true&lang=css&"
import style1 from "./Banner.vue?vue&type=style&index=1&id=56699aea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56699aea",
  null
  
)

export default component.exports